module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-46.3a69c5a3.png";